import React, { useRef, useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const MagneticWrapper = styled(motion.div)`
  display: inline-block;
  position: relative;
`;

const MagneticButton = ({ children, className, onClick, href, target, strength = 0.35, ...props }) => {
  const ref = useRef(null);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    if (!ref.current) return;
    const { clientX, clientY } = e;
    const { left, top, width, height } = ref.current.getBoundingClientRect();
    const centerX = left + width / 2;
    const centerY = top + height / 2;
    const distanceX = (clientX - centerX) * strength;
    const distanceY = (clientY - centerY) * strength;
    setPosition({ x: distanceX, y: distanceY });
  };

  const handleMouseLeave = () => {
    setPosition({ x: 0, y: 0 });
  };

  const Component = href ? motion.a : motion.button;

  return (
    <MagneticWrapper
      ref={ref}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      animate={{ x: position.x, y: position.y }}
      transition={{ type: "spring", stiffness: 250, damping: 20, mass: 0.1 }}
    >
      <Component
        className={className}
        onClick={onClick}
        href={href}
        target={target}
        {...props}
      >
        {children}
      </Component>
    </MagneticWrapper>
  );
};

export default MagneticButton;
